export enum BankView {
  BankReconciliation = 'BankReconciliation',
  ConnectModal = 'ConnectModal',
}
